import React, { useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
  Link,
} from "react-router-dom";
import Main from "./Main";
import styled from "styled-components";
import { CiSearch } from "react-icons/ci";
import { MdOutlineLanguage } from "react-icons/md";
import { HiMenuAlt3 } from "react-icons/hi";
import { IoClose } from "react-icons/io5";
import { IoIosArrowDown } from "react-icons/io";
import { Container } from "./style";
import BG from "./bg.png";
import Logo from "./logo.png";
import { useTranslation } from "react-i18next";
import Footer from "./Footer.jsx";

// Pages
import ActionPlan from "./pages/ActionPlan";
import BankList from "./pages/BankList";
import BanksReview from "./pages/BanksReview";
import BankStatistic from "./pages/BankStatistic";
import CallCenter from "./pages/CallCenter.jsx";
import ClubProgramm from "./pages/ClubProgramm";
import ClubStructure from "./pages/ClubStructure";
import EduCenter from "./pages/EduCenter";
import EduPresentation from "./pages/EduPresentation";
import FAQ from "./pages/FAQ";
import AwardsRegulation from "./pages/AwardsRegulation";

import FinanceSystem from "./pages/FinanceSystem";
import ForceTask from "./pages/ForceTask";
import Goals from "./pages/Goals";
import MacroEco from "./pages/MacroEco";
import Members from "./pages/Members";
import MoneyCredit from "./pages/MoneyCredit";
import OrgStructure from "./pages/OrgStructure";
import Requzite from "./pages/Requzite";
import Docs from "./pages/Docs";
import AboutUs from "./pages/AboutUs";
import Structure from "./pages/Structure";
import News from "./pages/News";
import AllNews from "./pages/AllNews";
import News1 from "./pages/News1";
import News2 from "./pages/News2";
import News3 from "./pages/News3";
import News4 from "./pages/News4";
import News5 from "./pages/News5";
import News6 from "./pages/News6";
import News7 from "./pages/News7";
import News8 from "./pages/News8";
import News9 from "./pages/News9";
import News10 from "./pages/News10";
import News11 from "./pages/News11";
import News12 from "./pages/News12";
import News13 from "./pages/News13";
import News14 from "./pages/News14";
import News15 from "./pages/News15";
import News16 from "./pages/News16";
import News17 from "./pages/News17";

const HeaderStyled = styled.div`
  height: 400px;
  background-image: url(${BG});
  background-size: cover;
  color: #fff;

  @media (max-width: 768px) {
    height: auto;
    min-height: 300px;
    padding-bottom: 30px;
  }

  > div {
    .tophead {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px 0;

      @media (max-width: 768px) {
        padding: 10px 0;
      }

      img {
        height: 60px;
        width: auto;
        
        @media (max-width: 768px) {
          height: 45px;
        }
      }

      .search {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 16px;
        cursor: pointer;
        transition: opacity 0.3s;

        &:hover {
          opacity: 0.8;
        }

        @media (max-width: 768px) {
          display: none;
        }
      }

      .right-section {
        display: flex;
        align-items: center;
        gap: 20px;

        .lang-toggle {
          display: flex;
          align-items: center;
          gap: 8px;
          cursor: pointer;
          font-size: 16px;
          font-weight: 500;
          transition: opacity 0.3s;

          &:hover {
            opacity: 0.8;
          }
        }

        .mobile-menu-btn {
          display: none;
          background: none;
          border: none;
          color: #fff;
          cursor: pointer;
          padding: 5px;
          transition: opacity 0.3s;

          &:hover {
            opacity: 0.8;
          }

          @media (max-width: 1024px) {
            display: block;
          }
        }
      }
    }
  }

  h1 {
    font-size: 40px;
    margin-top: 50px;
    font-weight: 700;

    @media (max-width: 768px) {
      font-size: 28px;
      margin-top: 30px;
      text-align: center;
    }
  }

  p {
    font-size: 24px;
    margin-top: 20px;
    font-weight: 300;

    @media (max-width: 768px) {
      font-size: 18px;
      margin-top: 15px;
      text-align: center;
    }
  }
`;

const Navigation = styled.nav`
  background: rgba(20, 30, 50, 0.85);
  backdrop-filter: blur(15px);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);

  @media (max-width: 1024px) {
    display: none;
  }

  .menu {
    display: flex;
    justify-content: space-between;
    list-style: none;
    padding: 0;
    margin: 0;

    > li {
      position: relative;
      flex: 1;
      text-align: center;

      &:not(:last-child) {
        border-right: 1px solid rgba(255, 255, 255, 0.08);
      }

      &:hover > .spann {
        background: rgba(255, 255, 255, 0.15);
      }

      &:hover .dropdown-content {
        opacity: 1;
        visibility: visible;
        transform: translateY(0);
      }

      .spann {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;
        padding: 16px 8px;
        cursor: pointer;
        transition: all 0.3s;
        font-size: 13.5px;
        font-weight: 600;
        color: #fff;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
        white-space: nowrap;

        a {
          color: #fff;
          text-decoration: none;
        }

        svg {
          opacity: 0.8;
          font-size: 12px;
        }
      }

      .dropdown-content {
        position: absolute;
        top: 100%;
        left: 50%;
        transform: translateX(-50%) translateY(-10px);
        background: rgba(25, 35, 55, 0.97);
        backdrop-filter: blur(15px);
        min-width: 280px;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
        z-index: 100;
        opacity: 0;
        visibility: hidden;
        transition: all 0.3s ease;
        border-radius: 8px;
        overflow: hidden;
        border: 1px solid rgba(255, 255, 255, 0.1);

        &:hover {
          opacity: 1;
          visibility: visible;
          transform: translateX(-50%) translateY(0);
        }

        li {
          border-bottom: 1px solid rgba(255, 255, 255, 0.08);

          &:last-child {
            border-bottom: none;
          }

          &:hover {
            background: rgba(255, 255, 255, 0.12);
          }

          a {
            display: block;
            padding: 14px 24px;
            color: #fff;
            text-decoration: none;
            transition: all 0.3s;
            font-size: 15px;
            font-weight: 500;
            text-align: left;

            &:hover {
              padding-left: 32px;
              background: linear-gradient(90deg, rgba(255, 255, 255, 0.1) 0%, transparent 100%);
            }
          }
        }
      }
    }
  }
`;

const MobileMenu = styled.div`
  position: fixed;
  top: 0;
  right: ${props => props.$isOpen ? '0' : '-100%'};
  width: 100%;
  max-width: 400px;
  height: 100vh;
  background: rgba(30, 30, 30, 0.98);
  backdrop-filter: blur(20px);
  z-index: 1000;
  transition: right 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  overflow-y: auto;
  box-shadow: ${props => props.$isOpen ? '-5px 0 20px rgba(0, 0, 0, 0.3)' : 'none'};

  .mobile-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);

    .logo {
      height: 40px;
    }

    .close-btn {
      background: none;
      border: none;
      color: #fff;
      cursor: pointer;
      padding: 5px;
      transition: transform 0.3s;

      &:hover {
        transform: rotate(90deg);
      }
    }
  }

  .mobile-menu-list {
    list-style: none;
    padding: 20px 0;
    margin: 0;

    .mobile-menu-item {
      border-bottom: 1px solid rgba(255, 255, 255, 0.05);

      .menu-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px 20px;
        color: #fff;
        cursor: pointer;
        font-weight: 500;
        font-size: 16px;
        transition: background 0.3s;

        &:hover {
          background: rgba(255, 255, 255, 0.05);
        }

        a {
          color: #fff;
          text-decoration: none;
          flex: 1;
        }

        .arrow {
          transition: transform 0.3s;
          transform: ${props => 'rotate(0deg)'};
        }

        .arrow.open {
          transform: rotate(180deg);
        }
      }

      .submenu {
        max-height: ${props => '0'};
        overflow: hidden;
        transition: max-height 0.3s ease;
        background: rgba(0, 0, 0, 0.2);

        &.open {
          max-height: 500px;
        }

        li {
          a {
            display: block;
            padding: 12px 20px 12px 40px;
            color: rgba(255, 255, 255, 0.8);
            text-decoration: none;
            font-size: 14px;
            transition: all 0.3s;

            &:hover {
              background: rgba(255, 255, 255, 0.05);
              padding-left: 45px;
              color: #fff;
            }
          }
        }
      }
    }
  }
`;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(3px);
  z-index: 999;
  opacity: ${props => props.$isOpen ? '1' : '0'};
  visibility: ${props => props.$isOpen ? 'visible' : 'hidden'};
  transition: all 0.3s;
`;

const ContentWrapper = styled.div`
  background: #f6f6f6;
  padding: 20px 0;
`;

const MobileMenuItem = ({ title, children, onClick }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <li className="mobile-menu-item">
      <div className="menu-title" onClick={() => setIsOpen(!isOpen)}>
        {onClick ? (
          <span onClick={onClick}>{title}</span>
        ) : (
          <span>{title}</span>
        )}
        {children && (
          <IoIosArrowDown 
            className={`arrow ${isOpen ? 'open' : ''}`} 
            size={20} 
          />
        )}
      </div>
      {children && (
        <ul className={`submenu ${isOpen ? 'open' : ''}`}>
          {children}
        </ul>
      )}
    </li>
  );
};

const App = () => {
  const { i18n, t } = useTranslation();
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleLanguage = () => {
    const newLanguage = i18n.language === "ru" ? "tj" : "ru";
    i18n.changeLanguage(newLanguage);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const getHeaderContent = () => {
    const pathToKey = {
      "/about-us": "aboutUs",
      "/docs": "docs",
      "/structure": "structure",
      "/org-structure": "orgStructure",
      "/members": "members",
      "/requzite": "requzite",
      "/money": "moneyCredit",
      "/money-credit": "moneyCredit",
      "/goals": "goals",
      "/action-plan": "actionPlan",
      "/banks-reviews": "banksReviews",
      "/banks-list": "banksList",
      "/force-task": "forceTask",
      "/edu-center": "eduCenter",
      "/edu-presentation": "eduPresentation",
      "/call-center": "callCenter",
      "/faq": "faq",
      "/all-news": "allNews",
    };

    const key = location.pathname.startsWith("/news") ? "news" : pathToKey[location.pathname] || "default";

    return {
      h1: t(`headers.${key}.h1`),
      p: t(`headers.${key}.p`),
    };
  };

  const { h1, p } = getHeaderContent();

  return (
    <div style={{ backgroundColor: "#f6f6f6" }}>
      <HeaderStyled>
        <Container>
          <div className="tophead">
            <Link to="/">
              <img src={Logo} alt="Logo" />
            </Link>
            <div className="search">
              Поиск
              <CiSearch size={20} />
            </div>
            <div className="right-section">
              <div className="lang-toggle" onClick={toggleLanguage}>
                <MdOutlineLanguage size={24} />
                {i18n.language === "ru" ? "РУС" : "TОЧ"}
              </div>
              <button 
                className="mobile-menu-btn" 
                onClick={() => setIsMobileMenuOpen(true)}
                aria-label="Open menu"
              >
                <HiMenuAlt3 size={32} />
              </button>
            </div>
          </div>
        </Container>

        <Navigation>
          <Container>
            <ul className="menu">
              <li>
                <span className="spann">
                  <Link to="/about-us">{t("menu.aboutUs")}</Link>
                  <IoIosArrowDown size={14} />
                </span>
                <ul className="dropdown-content">
                  <li><Link to="/docs">{t("menu.foundingDocs")}</Link></li>
                  <li><Link to="/structure">{t("menu.structure")}</Link></li>
                  <li><Link to="/org-structure">{t("menu.orgStructure")}</Link></li>
                  <li><Link to="/members">{t("menu.members")}</Link></li>
                  <li><Link to="/requzite">{t("menu.requisites")}</Link></li>
                </ul>
              </li>
              <li>
                <span className="spann">
                  {t("menu.monetaryPolicy")}
                  <IoIosArrowDown size={14} />
                </span>
                <ul className="dropdown-content">
                  <li><Link to="/money-credit">{t("menu.strategy")}</Link></li>
                  <li><Link to="/goals">{t("menu.goalsAndObjectives")}</Link></li>
                  <li><Link to="/action-plan">{t("menu.actionPlan")}</Link></li>
                </ul>
              </li>
              <li>
                <span className="spann">
                  {t("menu.financialSystem")}
                  <IoIosArrowDown size={14} />
                </span>
                <ul className="dropdown-content">
                  <li><Link to="/banks-reviews">{t("menu.bankReviews")}</Link></li>
                  <li><Link to="/banks-list">{t("menu.bankMembers")}</Link></li>
                </ul>
              </li>
              <li>
                <span className="spann">
                  {t("menu.statistics")}
                  <IoIosArrowDown size={14} />
                </span>
                <ul className="dropdown-content">
                  <li><Link to="/macro-eco">{t("menu.macroIndicators")}</Link></li>
                  <li><Link to="/bank-stat">{t("menu.bankStats")}</Link></li>
                </ul>
              </li>
              <li>
                <span className="spann">
                  {t("menu.bankersClub")}
                  <IoIosArrowDown size={14} />
                </span>
                <ul className="dropdown-content">
                  <li><Link to="/force-task">{t("menu.position")}</Link></li>
                  <li><Link to="/club-structure">{t("menu.clubStructure")}</Link></li>
                  <li><Link to="/club-program">{t("menu.clubProgram")}</Link></li>
                </ul>
              </li>
              <li>
                <span className="spann">
                  {t("menu.eduCenter")}
                  <IoIosArrowDown size={14} />
                </span>
                <ul className="dropdown-content">
                  <li><Link to="/edu-center">{t("menu.trainingPlan")}</Link></li>
                  <li><Link to="/edu-presentation">{t("menu.presentations")}</Link></li>
                </ul>
              </li>
              <li>
                <span className="spann">
                  {t("menu.financialOmbudsman")}
                  <IoIosArrowDown size={14} />
                </span>
                <ul className="dropdown-content">
                  <li><Link to="/call-center">{t("menu.callCenter")}</Link></li>
                  <li><Link to="/faq">{t("menu.faq")}</Link></li>
                </ul>
              </li>
            </ul>
          </Container>
        </Navigation>

        <Overlay $isOpen={isMobileMenuOpen} onClick={closeMobileMenu} />
        
        <MobileMenu $isOpen={isMobileMenuOpen}>
          <div className="mobile-header">
            <img src={Logo} alt="Logo" className="logo" />
            <button 
              className="close-btn" 
              onClick={closeMobileMenu}
              aria-label="Close menu"
            >
              <IoClose size={32} />
            </button>
          </div>
          <ul className="mobile-menu-list">
            <MobileMenuItem title={t("menu.aboutUs")}>
              <li><Link to="/docs" onClick={closeMobileMenu}>{t("menu.foundingDocs")}</Link></li>
              <li><Link to="/structure" onClick={closeMobileMenu}>{t("menu.structure")}</Link></li>
              <li><Link to="/org-structure" onClick={closeMobileMenu}>{t("menu.orgStructure")}</Link></li>
              <li><Link to="/members" onClick={closeMobileMenu}>{t("menu.members")}</Link></li>
              <li><Link to="/requzite" onClick={closeMobileMenu}>{t("menu.requisites")}</Link></li>
            </MobileMenuItem>
            
            <MobileMenuItem title={t("menu.monetaryPolicy")}>
              <li><Link to="/money-credit" onClick={closeMobileMenu}>{t("menu.strategy")}</Link></li>
              <li><Link to="/goals" onClick={closeMobileMenu}>{t("menu.goalsAndObjectives")}</Link></li>
              <li><Link to="/action-plan" onClick={closeMobileMenu}>{t("menu.actionPlan")}</Link></li>
            </MobileMenuItem>
            
            <MobileMenuItem title={t("menu.financialSystem")}>
              <li><Link to="/banks-reviews" onClick={closeMobileMenu}>{t("menu.bankReviews")}</Link></li>
              <li><Link to="/banks-list" onClick={closeMobileMenu}>{t("menu.bankMembers")}</Link></li>
            </MobileMenuItem>
            
            <MobileMenuItem title={t("menu.statistics")}>
              <li><Link to="/macro-eco" onClick={closeMobileMenu}>{t("menu.macroIndicators")}</Link></li>
              <li><Link to="/bank-stat" onClick={closeMobileMenu}>{t("menu.bankStats")}</Link></li>
            </MobileMenuItem>
            
            <MobileMenuItem title={t("menu.bankersClub")}>
              <li><Link to="/force-task" onClick={closeMobileMenu}>{t("menu.position")}</Link></li>
              <li><Link to="/club-structure" onClick={closeMobileMenu}>{t("menu.clubStructure")}</Link></li>
              <li><Link to="/club-program" onClick={closeMobileMenu}>{t("menu.clubProgram")}</Link></li>
            </MobileMenuItem>
            
            <MobileMenuItem title={t("menu.eduCenter")}>
              <li><Link to="/edu-center" onClick={closeMobileMenu}>{t("menu.trainingPlan")}</Link></li>
              <li><Link to="/edu-presentation" onClick={closeMobileMenu}>{t("menu.presentations")}</Link></li>
            </MobileMenuItem>
            
            <MobileMenuItem title={t("menu.financialOmbudsman")}>
              <li><Link to="/call-center" onClick={closeMobileMenu}>{t("menu.callCenter")}</Link></li>
              <li><Link to="/faq" onClick={closeMobileMenu}>{t("menu.faq")}</Link></li>
            </MobileMenuItem>
          </ul>
        </MobileMenu>

        <Container>
          <h1>{h1}</h1>
          <p>{p}</p>
        </Container>
      </HeaderStyled>
      <ContentWrapper>
        <Container>
          <Routes>
            <Route path="/" element={<Main />} />
            <Route path="/docs" element={<Docs />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/structure" element={<Structure />} />
            <Route path="/org-structure" element={<OrgStructure />} />
            <Route path="/members" element={<Members />} />
            <Route path="/requzite" element={<Requzite />} />
            <Route path="/money-credit" element={<MoneyCredit />} />
            <Route path="/goals" element={<Goals />} />
            <Route path="/action-plan" element={<ActionPlan />} />
            <Route path="/banks-reviews" element={<BanksReview />} />
            <Route path="/banks-list" element={<BankList />} />
            <Route path="/force-task" element={<ForceTask />} />
            <Route path="/edu-center" element={<EduCenter />} />
            <Route path="/edu-presentation" element={<EduPresentation />} />
            <Route path="/call-center" element={<CallCenter />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/macro-eco" element={<MacroEco />} />
            <Route path="/bank-stat" element={<BankStatistic />} />
            <Route path="/club-structure" element={<ClubStructure />} />
            <Route path="/club-program" element={<ClubProgramm />} />
            <Route path="/news1" element={<News1 />} />
            <Route path="/news2" element={<News2 />} />
            <Route path="/news3" element={<News3 />} />
            <Route path="/news4" element={<News4 />} />
            <Route path="/news5" element={<News5 />} />
            <Route path="/news6" element={<News6 />} />
            <Route path="/news7" element={<News7 />} />
            <Route path="/news8" element={<News8 />} />
            <Route path="/news9" element={<News9 />} />
            <Route path="/news10" element={<News10 />} />
            <Route path="/news11" element={<News11 />} />
            <Route path="/news12" element={<News12 />} />
            <Route path="/news13" element={<News13 />} />
            <Route path="/news14" element={<News14 />} />
            <Route path="/news15" element={<News15 />} />
            <Route path="/news16" element={<News16 />} />
            <Route path="/news17" element={<News17 />} />
            <Route path="/news/:id" element={<News />} />
            <Route path="/all-news" element={<AllNews />} />
            <Route path="/awards-regulation" element={<AwardsRegulation />} />


          </Routes>
        </Container>
      </ContentWrapper>
      <Footer />
    </div>
  );
};

export default App;